import React from 'react';
import { Box, Button } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import { isSafeButtonUrl } from '../utils/querylessChartTypes';

/**
 * Tile de dashboard que es solo un boton con un link fijo a otra vista externa.
 * Sin consulta SQL, sin datos propios.
 */
export default function ButtonWidget({ label, url }) {
  const safe = isSafeButtonUrl(url);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', p: 1 }}>
      <Button
        variant="contained"
        size="large"
        endIcon={<LaunchIcon />}
        disabled={!safe}
        component={safe ? 'a' : 'button'}
        href={safe ? url : undefined}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {label || 'Enlace'}
      </Button>
    </Box>
  );
}

/** Excel del dashboard completo: una fila con la etiqueta y la URL, ver excelExport.js. */
export function buttonRowsForExport(chart) {
  return [{ Etiqueta: chart?.label || '', URL: chart?.buttonUrl || '' }];
}
